<template>
  <ul v-if="pager.pages && pager.pages.length" class="c-pagination" :style="ulStyles">
    <!-- <li class="c-pagination__page--first" :class="{'disabled': pager.currentPage === 1}" :style="liStyles">
        <a @click="dipatchChange(1)" :style="aStyles">{{ $t('experiments.paginator.first') }}</a>
    </li> -->
    <li class="c-pagination__page--prev" :class="{ 'disabled': pager.currentPage === 1 }" :style="liStyles">
        <a @click="dipatchChange(pager.currentPage - 1)" :style="aStyles">{{ $t('experiments.paginator.prev') }}</a>
    </li>
    <li v-for="page in pager.pages" :key="page" class="c-pagination__page" :class="{'current': pager.currentPage === page}" :style="liStyles">
        <a @click="dipatchChange(page)" :style="aStyles">{{ page }}</a>
    </li>
    <li class="c-pagination__page--next" :class="{'disabled': pager.currentPage === pager.totalPages}" :style="liStyles">
        <a @click="dipatchChange(pager.currentPage + 1)" :style="aStyles">{{ $t('experiments.paginator.next') }}</a>
    </li>
    <!-- <li class="c-pagination__page--last" :class="{'disabled': pager.currentPage === pager.totalPages}" :style="liStyles">
        <a @click="dipatchChange(pager.totalPages)" :style="aStyles">{{ $t('experiments.paginator.last') }}</a>
    </li> -->
  </ul>
</template>

<style scoped lang="scss">
  a {
    cursor: pointer;
  }

  li.disabled a {
    cursor : not-allowed;
    opacity: 0.5;
    text-decoration: none;

    &:hover {
      opacity: 0.5;
    }
  }
</style>

<script>
import paginate from 'jw-paginate'

const defaultStyles = {}

export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    initialPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    maxPages: {
      type: Number,
      default: 5,
    },
    styles: {
      type: Object,
    },
    disableDefaultStyles: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pager: {},
      ulStyles: {},
      liStyles: {},
      aStyles: {},
    }
  },
  created() {
    if (!this.$listeners.changePage) {
      throw Error('Missing required event listener: changePage')
    }

    // set default styles unless disabled
    if (!this.disableDefaultStyles) {
      this.ulStyles = defaultStyles.ul
      this.liStyles = defaultStyles.li
      this.aStyles = defaultStyles.a
    }

    // merge custom styles with default styles
    if (this.styles) {
      this.ulStyles = { ...this.ulStyles, ...this.styles.ul }
      this.liStyles = { ...this.liStyles, ...this.styles.li }
      this.aStyles = { ...this.aStyles, ...this.styles.a }
    }

    // set to initial page
    this.setPage(this.initialPage)
  },
  methods: {
    setPage(page) {
      const { items, pageSize, maxPages } = this

      // get new pager object for specified page
      const pager = paginate(
        items.length,
        page,
        pageSize,
        maxPages,
      )

      this.pager = pager
    },
    dipatchChange(page) {
      if (page === 0 || page > this.pager.totalPages) {
        return
      }

      this.setPage(page)
      this.$emit('changePage', page)
    },
  },
}
</script>
